// @ts-nocheck
import FastenersReducer, { FastenersActions } from "@store/Framework/Store/Store/Data/Fasteners/FastenersReducer";
import LedgersReducer, { LedgersActions } from "@store/Framework/Store/Store/Data/Ledgers/LedgersReducer";
import ProductsReducer, { ProductsActions } from "@store/Framework/Store/Store/Data/Products/ProductsReducer";
import { combineReducers } from "redux";

const dataReducer = combineReducers({
    fasteners: FastenersReducer,
    ledgers: LedgersReducer,
    products: ProductsReducer,
});

export type DataActions = FastenersActions | LedgersActions | ProductsActions;

export default dataReducer;
